import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"
export default class extends Controller {
    toGuests(event) {
        event.preventDefault()
        const trigger = document.querySelector("#guests-tab")
        if (!trigger) return
        // Use Bootstrap's API to switch tabs
        const tab = bootstrap.Tab.getOrCreateInstance(trigger)
        tab.show()
        // optional: scroll into view
        document.getElementById("guests-tab-pane")?.scrollIntoView({ behavior: "smooth", block: "start" })
    }
}